var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_70511)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.200195,
    y: 0.25,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2002 16.25C14.4082 16.25 16.2002 14.458 16.2002 12.25C16.2002 10.042 14.4082 8.25 12.2002 8.25C9.9922 8.25 8.2002 10.042 8.2002 12.25C8.2002 14.458 9.9922 16.25 12.2002 16.25ZM12.2002 14.65C13.525 14.65 14.6002 13.5748 14.6002 12.25C14.6002 10.9252 13.525 9.85 12.2002 9.85C10.8754 9.85 9.8002 10.9252 9.8002 12.25C9.8002 13.5748 10.8754 14.65 12.2002 14.65Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2002 13.25C12.7525 13.25 13.2002 12.8023 13.2002 12.25C13.2002 11.6977 12.7525 11.25 12.2002 11.25C11.6479 11.25 11.2002 11.6977 11.2002 12.25C11.2002 12.8023 11.6479 13.25 12.2002 13.25Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.200195 16.25H24.2002V24.25H0.200195V16.25Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.200195 0.25H24.2002V8.25H0.200195V0.25Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_70511"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.200195,
    y: 0.25,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/India.fe2f6d073666b7e3f2f46cbc06daab79.svg";
export { ForwardRef as ReactComponent };